import type { DocMigration } from "../docMigration";

export interface EdgeIdMappedItem {
  edgeId: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_84: DocMigration = {
  maxSchemaVersion: "0.0.84",
  description: "Remap or drop room edge index on missing edges",
  apply(json: any) {
    if (!json.roomLayouts) {
      return json;
    }

    if (!json.rooms) {
      return json;
    }

    for (const layoutId in json.roomLayouts) {
      const layout = json.roomLayouts[layoutId];
      if (!layout) {
        continue;
      }
      const room = json.rooms[layoutId];
      if (!room) {
        continue;
      }
      const edgeIds = room.edgeIds ?? [];
      if (edgeIds.length === 0) {
        continue;
      }

      const fields = [
        "columnPatterns",
        "edgeDimensionBehavior",
        "edgeLabels",
        "elevationNotes",
        "footingPatterns",
        "openingPatterns",
        "wallThicknesses",
      ];

      for (const field of fields) {
        migrateDoc0084RemapOrRemoveLayoutItemsForMissingRoomEdgeIds(layout, field, edgeIds);
      }
    }

    return json;
  },
};

function migrateDoc0084RemapOrRemoveLayoutItemsForMissingRoomEdgeIds(
  layout: any,
  layoutKey: string,
  edgeIds: string[],
) {
  const indexesToRemove: string[] = [];
  const layoutItems = (layout[layoutKey] as []) ?? [];
  for (const index in layoutItems) {
    const x = layoutItems[index] as EdgeIdMappedItem;

    if (!x?.edgeId) {
      continue;
    }

    // if edge id found in room, do nothing
    if (edgeIds.indexOf(x.edgeId) !== -1) {
      continue;
    }

    //otherwise, get rid of the orphan item
    indexesToRemove.push(index);
  }

  for (const indexToRemove of indexesToRemove) {
    const layoutArr = layout[layoutKey] as [];
    layoutArr.splice(parseInt(indexToRemove), 1);
  }
}

export default migration_0_0_84;
